var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.729,
    height: 36.729,
    viewBox: "0 0 36.729 36.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step_3_off",
    "data-name": "step 3 off",
    transform: "translate(-96.25 -26.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38461",
    "data-name": "Path 38461",
    d: "M114.615,26.25a18.365,18.365,0,1,0,18.365,18.365A18.385,18.385,0,0,0,114.615,26.25Zm0,34.689a16.324,16.324,0,1,1,16.324-16.324A16.344,16.344,0,0,1,114.615,60.939Z",
    transform: "translate(0)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38462",
    "data-name": "Path 38462",
    d: "M247.18,209.023l-4.381-4.381-1.442,1.442,5.1,5.1a1.02,1.02,0,0,0,1.442,0l10.2-10.2-1.442-1.442Z",
    transform: "translate(-134.605 -160.749)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.c8dd6218211dd4abcb709ea013b58ce6.svg";
export { ForwardRef as ReactComponent };